import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { FF_MAGIC_LINK_AUTH } from '../../constants/authorization.constant';
import { AuthorizationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationAuthorizationActionType, LoginFlowLabels } from '~shared/modules/application-event/constants';
import { MAGIC_LINK_BAG_KEY, PasswordlessService } from '../../services/passwordless.service';

@Component({
  selector: 'app-login-flow-type',
  templateUrl: './login-flow-type.component.html',
  styleUrls: ['./login-flow-type.component.scss'],
})
export class LoginFlowTypeComponent implements OnDestroy {
  unsubscribe$ = new Subject();

  constructor(
    private applicationEventService: ApplicationEventService,
    private passwordlessService: PasswordlessService
  ) {}

  onMagicLoginClick(): void {
    this.applicationEventService.publishIfFFEnabled(
      FF_MAGIC_LINK_AUTH,
      new AuthorizationApplicationEvent(
        ApplicationAuthorizationActionType.ChooseLoginOptionClick,
        LoginFlowLabels.PasswordlessLogin
      )
    );
    this.passwordlessService.triggerMagicLink();
  }

  onPasswordLoginClick(): void {
    this.applicationEventService.publishIfFFEnabled(
      FF_MAGIC_LINK_AUTH,
      new AuthorizationApplicationEvent(
        ApplicationAuthorizationActionType.ChooseLoginOptionClick,
        LoginFlowLabels.PasswordLogin
      )
    );
    const magicLinkBagStr = localStorage.getItem(MAGIC_LINK_BAG_KEY);
    if (magicLinkBagStr) {
      const magicLinkBag = JSON.parse(magicLinkBagStr);
      this.passwordlessService.normalLoginFlow(magicLinkBag.email, magicLinkBag.backUrl);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
